import React from 'react';
import OrMaybe from './OrMaybe';

export default function OrMaybesList({list}) {
  if (!list) {return "Error: no list of 'or maybes' provided";}
  return <div className="or-maybes-list">
    {list.map((om, i) => <OrMaybe data={om} key={i} listItem />)}
  </div>;
};
